import {ENV} from '../_helpers/EnvHelper'

export const RoleName: any = {
  superAdmin: 'Super Admin',
  subAdmin: 'Cellcast Admin',
  staffAdmin: 'Staff Admin',
  accountManager: 'Account Manager',
  sales: 'Sales',
  supportStaff: 'Support',
  owner: 'Owner',
  whitelabelAdmin: 'White Label Admin',
  affiliate: 'Affiliate',
}

export const RouteName: any = {
  '/dashboard': ['Dashboard', 'Home'],
  '/user-list': ['User list', 'Home'],
  '/whitelabel-list': ['White label list', 'Home'],
  '/whiteLabel-profile/whiteLabelOverview': ['Overview', 'White label profile'],
  '/whiteLabel-profile/whiteLabelCredit': ['Credit', 'White label profile'],
  '/whiteLabel-profile/whiteLabelUserList': ['Assigned User', 'White label profile'],

  '/staff-profile/overview': ['Overview', 'Staff profile'],
  '/staff-profile/credits': ['Credit', 'Staff profile'],
  '/staff-profile/assignUser': ['Assigned User', 'Staff profile'],
  '/staff-profile/commision': ['Commision', 'Staff pofile'],
  '/staff-profile/more': ['More', 'Staff profile'],

  // '/campaign-log': '',
  '/support-ticket': '',
  '/gateway': ['Gateway management', 'Home'],
  '/dedicated_Number': ['Dedicated number', 'Home'],
  '/setting/payment_gateways': ['Payment Gateway', 'Home'],
  '/setting/global_ratecard': ['Global rate card', 'Home'],
  '/setting/opt_out': ['Custom opt-out'],
  '/setting/opt-out-list': ['Custom opt-out', 'settings'],
  '/opt-out': ['Custom opt-out', 'Home'],
  '/setting/global_setting': ['Global settings', 'Home'],
  '/setting/fraud_keyword': ['Fraud Keyword', 'Home'],
  ///////////////

  '/accounts/overview': ['Account overview', 'Home-Account'],
  '/accounts/staff-account': ['Staff Account', 'Home-Account'],
  '/accounts/settings': ['Setting', 'Home-Account'],
  '/accounts/billing': ['Billing', 'Home-Account'],
  "/accounts/sender-id's": ["Sender id's", 'Home-Account'],
  '/sender-id': ["Sender id's", 'Home-Account'],
  '/accounts/team-list': ['Team list', 'Home-Account'],
  '/accounts/api-keys': ['API KEYS', 'Home-Account'],
  '/accounts/referral': ['Referral', 'Home-Account'],
  '/accounts/balance-history': ['Credit History', 'Home-Account'],
  '/accounts/notifications': ['Notifications', 'Home-Account'],

  '/subAccount/user': ['Owner Account', 'Home'],

  '/user-profile/overview': ['Overview', 'User Profile'],
  '/user-profile/billing': ['Billing', 'User Profile'],
  '/user-profile/assignStaff': ['Assign-Staff', 'User Profile'],
  '/user-profile/more': ['More', 'User Profile'],
  /////////////////Front End///////////
  '/new-message': ['New message', 'Home'],
  '/our-template': ['Our-Template', 'Template'],
  '/New-Template': ['New Template', 'Home'],
  '/templates/template': ['Templates', 'Home'],
  '/templates/message-template': ['Templates', 'Base Template'],
  '/inbox': ['Inbox', 'Home'],

  '/contacts/subscriber': ['Contacts', 'Contact'],
  '/contacts/list': ['List', 'Contact'],
  '/contacts/list/:id': ['List Detail', 'List'],
  '/contacts/segments': ['Segments', 'Contact'],
  '/contacts/tags': ['Tags', 'Contact'],
  '/contacts/promo-action': ['Promo Action', 'Contact'],
  '/contacts/unsubscribe': ['Unsubscribe', 'Contact'],

  '/templates/savedCampaign': ['Saved Campaigns', 'Home'],
  // '/landing-page': ['Landing pages', 'Home'],
  '/campaign-log': ['Campaign Log', 'Home'],
  '/activity-log': ['Activity Log', 'Home'],
  '/landing-page': ['Landing pages', 'Home'],
  '/create-langing-page': ['Landing pages', 'Home'],
  '/opt-out-list': ['Custom opt-out', 'Home'],
  '/email-to-sms': ['Email to SMS & MMS', 'Home'],

  '/integration': ['Integration', 'Home'],
  '/tools/form': ['Lead Capture Form', 'Home'],
  '/automation': ['Automations', 'Home'],
  '/automation/new': ['Automation', 'Home'],
  '/automation/flow/:id': ['Automation', 'Home'],
  '/automation/logs': ['Contacts in Flow Activity', 'Home'],
  '/automation/logs/:id': ['Contacts in Flow Activity', 'Home'],
  '/automation/contacts-in-flows/:id': ['Contacts in Flow', 'Home'],
  '/automation/contacts-in-flows/event-logs/:id': ['Contact in Flow Activity', 'Home'],
  '/filterContact': ['Contacts', 'Tag'],
  '/segmentfilterContact': ['Contacts', 'Segment'],
  '/topup': ['Purchase Credit', 'Home'],
  '/admin/message_approval': ['Message Approval', 'Home'],
  '/templates/automation/new': ['Automation', 'Base Template'],
  '/templates/automation/flow/:id': ['Automation', 'Base Template'],

  // report
  '/report-analytics/insight': ['Insight', 'Reports & Analytics'],
  '/report-analytics/bulk-messages': ['Bulk Message', 'Reports & Analytics'],
  '/report-analytics/quick-messages': ['Quick Message', 'Reports & Analytics'],
  '/report-analytics/email-to-sms-messages': ['Email To Sms Message', 'Reports & Analytics'],
  '/report-analytics/api-messages': ['Api Message', 'Reports & Analytics'],
  '/report-analytics/file-scheduler-messages': ['File Scheduler', 'Reports & Analytics'],
  '/report-analytics/short-link': ['Short Link', 'Reports & Analytics'],
  '/report-analytics/landing-pages': ['Landing Page', 'Reports & Analytics'],
  '/report-analytics/activity-logs': ['Activity Logs', 'Reports & Analytics'],
  '/report-analytics/flow': ['Flow Report', 'Reports & Analytics'],

  '/eofy/customer_replies': ['Customer replies', 'Reports & Analytics'],
  '/eofy/snapshot': ['snapshot', 'Reports & Analytics'],
  '/eofy/contacts': ['contacts', 'Reports & Analytics'],
  '/eofy/opt_out': ['Opt-Out', 'Reports & Analytics'],
  '/eofy/short_link': ['short_link', 'Reports & Analytics'],
  '/eofy/bounced': ['bounced', 'Reports & Analytics'],

  // file scheduler
  '/file-scheduler': ['File Scheduler', 'List'],
  '/file-scheduler/form': ['File Scheduler', 'Form'],
  '/file-scheduler/review': ['File Scheduler', 'Review'],

  // help
  '/help/how-to-videos': ['How To Videos', 'Help'],

  // wallet card
  '/wallet-card': ['Cards', 'Home'],
  '/wallet-card/subscription': ['Subscription', 'Wallet Card'],
  '/wallet-card/subscription/activate': ['Subscription Activation', 'Wallet Card'],
  '/wallet-card/subscription/demo-leadz-app': ['Schedule LeadzApp Demo', 'Wallet Card'],
  '/wallet-card/subscription/get-started': ['Get Started', 'Wallet Card'],
  '/wallet-card-report': ['Wallet Card Report', 'Home'],
  '/wallet-card/create': ['Cards', 'Home'],
  '/wallet-card/edit/:cardId': ['Cards', 'Home'],
  '/wallet-card/detail/:cardId': ['Cards', 'Home'],
  '/team-list': ['Invite Users', 'Wallet Card'],

  '/card-templates': ['Card Templates', 'Home'],
  '/card-templates/create': ['Card Templates', 'Home'],
  '/card-templates/edit/:cardId': ['Card Templates', 'Home'],
  '/card-templates/detail/:cardId': ['Card Templates', 'Home'],
  '/promo-action': ['Card Offers', 'Home'],

  // contact collection
  '/contact-collection': ['Lead Management', 'Home'],
  '/record-list/:id': ['Record List', 'Home'],

  // wallet card report
  '/report-wallet-card': ['Wallet Card Report', 'Home'],
}

export const GLOBAL_SETTINGS_TYPE = {
  BULK_SMS_REPLY_STOP_OUTPUT: 'bulkSMSReplyStopOutout',
  BULK_MMS_REPLY_STOP_OUTPUT: 'bulkMMSReplyStopOutout',
  QUICK_SMS_REPLY_STOP_OUTPUT: 'quickSMSReplyStopOutout',
  QUICK_MMS_REPLY_STOP_OUTPUT: 'quickMMSReplyStopOutout',
  QUICK_MESSAGE_TO_UNSUB_CONTACT: 'sendQuickMessageToUnsubContact',
  BULK_MESSAGE_TO_UNSUB_CONTACT: 'sendBulkMessageToUnsubContact',
  EMAIL_TO_SMS_REPLY_STOP_OUTPUT: 'emailToSMSReplyStopOutout',
  SENDER_IDS_DISABLE_SEND_OTP: 'disableSendSenderIdVerificationCode',
  SEND_WITH_CUSTOM_PRICE: 'sendWithCustomPrice',
  NEW_NAVIGATION: 'navigationV2',
  NEW_NAVIGATION_V3: 'navigationV3',
  NEW_SUB_CLIENT_AUTO_VERIFY: 'newSubClientAutoVerify',
  NEW_INBOX: 'newInbox',
}

export const ACCOUNT_TYPE = {
  PREPRAID: 'prepaid',
  POSTPAID: 'postpaid',
}

export const STRIPE_PAYMENT_STATUS = {
  DRAFT: 'draft',
  OPEN: 'open',
  PAID: 'paid',
  VOID: 'void',
  UNCOLLECTIBLE: 'uncollectible',
}

export const QUICK_CONTACT_LIMIT = 500

export const CONTACT_FORMAT_REGEX =
  /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[4])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/gm

export const REGION_API_URLS: Record<string, string> = {
  NZ: ENV().REACT_APP_NZ_URL || '',
  AU: ENV().REACT_APP_AU_URL || '',
  UK: ENV().REACT_APP_UK_URL || '',
  US: ENV().REACT_APP_US_URL || '',
  ID: ENV().REACT_APP_ID_URL || '',
}

export const REGION = {
  AU: 'au',
  UK: 'uk',
  US: 'us',
  NZ: 'nz',
  ID: 'id',
}

export const REGION_ARRAYS: {value: string; label: string}[] = [
  {
    value: 'au',
    label: 'Australia',
  },
  {
    value: 'us',
    label: 'United States',
  },
  {
    value: 'uk',
    label: 'United Kingdom',
  },
  {
    value: 'nz',
    label: 'New Zealand',
  },
  {
    value: 'id',
    label: 'Indonesia',
  },
]

export const NUMBER_TYPE = {
  SMS: 'SMS',
  MMS: 'MMS',
  VOICE: 'VOICE',
}

export const GATEWAY_NAME_OPTIONS = [
  {value: 'G1', label: 'G1'},
  {value: 'G2', label: 'G2'},
  {value: 'G3', label: 'G3'},
  {value: 'G4', label: 'G4'},
  {value: 'G5', label: 'G5'},
  {value: 'G6', label: 'G6'},
  {value: 'G7', label: 'G7'},
  {value: 'G8', label: 'G8'},
  {value: 'G9', label: 'G9'},
  {value: 'G10', label: 'G10'},
  {value: 'G11', label: 'G11'},
  {value: 'G12', label: 'G12'},
  {value: 'G13', label: 'G13'},
  {value: 'G14', label: 'G14'},
  {value: 'G15', label: 'G15'},
]

export const DB_OPTIONS = [
  {value: 'SINCH MMS', label: 'SINCH MMS'},
  {value: 'SINCH SMS', label: 'SINCH SMS'},
  {value: 'MODICA SMS', label: 'MODICA SMS'},
  {value: 'TELSTRA MMS', label: 'TELSTRA MMS'},
  {value: 'TELSTRA SMS', label: 'TELSTRA SMS'},
]

export const typeMessageMap = {
  MMS: 'Send & Receive MMS/SMS with This Dedicated Number',
  VOICE: 'Enable Call Forwarding + Two-Way SMS with a Dedicated Number (DN)',
}

export type MessageType = keyof typeof typeMessageMap
// API s3 upload
export const API_ENDPOINTS = {
  MAIL_TEMPLATE: '/mail-template/presign',
  WALLET_CARD: '/wallet-cards/presign',
  WALLET_CARD_PREVIEW: '/wallet-cards/presign',
  VOICE: '/voices/presign',
}

export const GATEWAY_FEATURE_TYPE_OPTIONS = [
  {value: 'quick-sms', label: 'quick-sms'},
  {value: 'bulk-sms', label: 'bulk-sms'},
  {value: 'quick-mms', label: 'quick-mms'},
  {value: 'bulk-mms', label: 'bulk-mms'},
  {value: 'bulk', label: 'bulk'},
  {value: 'quick', label: 'quick'},
]

export const DEDICATED_NUMBER_OPTIONS = [
  {value: NUMBER_TYPE.SMS, label: NUMBER_TYPE.SMS},
  {value: NUMBER_TYPE.MMS, label: `${NUMBER_TYPE.SMS} + ${NUMBER_TYPE.MMS}`},
  {value: NUMBER_TYPE.VOICE, label: NUMBER_TYPE.VOICE},
]

export const AVAILABILITY_TYPE = {
  AVAILABLE: 'available',
  ALLOCATED: 'allocated',
  PENDING: 'pending',
}

export const AVAILABILITY_OPTIONS = [
  {value: '', label: 'Select'},
  {value: AVAILABILITY_TYPE.AVAILABLE, label: AVAILABILITY_TYPE.AVAILABLE},
  {value: AVAILABILITY_TYPE.ALLOCATED, label: AVAILABILITY_TYPE.ALLOCATED},
  {value: AVAILABILITY_TYPE.PENDING, label: AVAILABILITY_TYPE.PENDING},
]

export const BILLING_STATUS_TYPE = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  FREE: 'free',
}

export const BILLING_STATUS_OPTIONS = [
  {value: '', label: 'Select'},
  {value: BILLING_STATUS_TYPE.FREE, label: BILLING_STATUS_TYPE.FREE},
  {value: BILLING_STATUS_TYPE.MONTHLY, label: BILLING_STATUS_TYPE.MONTHLY},
  {value: BILLING_STATUS_TYPE.YEARLY, label: BILLING_STATUS_TYPE.YEARLY},
]

export const DEDICATED_NUMBER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended',
}

export const DEDICATED_NUMBER_STATUS_OPTIONS = [
  {value: '', label: 'Select'},
  {value: DEDICATED_NUMBER_STATUS.ACTIVE, label: DEDICATED_NUMBER_STATUS.ACTIVE},
  {value: DEDICATED_NUMBER_STATUS.INACTIVE, label: DEDICATED_NUMBER_STATUS.INACTIVE},
  {value: DEDICATED_NUMBER_STATUS.SUSPENDED, label: DEDICATED_NUMBER_STATUS.SUSPENDED},
]
